import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';

import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';
import { SearchCardData } from '../search-card/search-card.model';
import { WindowRef } from '../../shared-service/windowRef.service';

//declare var $: any;

@Component({
  selector: 'app-search-card',
  templateUrl: './search-card.component.html',
  styleUrls: ['./search-card.component.css', '../../../assets/css/custom-css/searchcard.css']
})
export class SearchCardComponent implements OnInit, AfterViewInit {

  constructor(public dataService: DataService, public bs: BaseService,private winRef:WindowRef) { }

  @Output() openEvent = new EventEmitter<object>();
  @Input() searchCardDataList: SearchCardData[] = [];
  @Input() showProgressBar: boolean = false;

  ngOnInit() {

  }

  ngAfterViewInit() {

  }

  OpenItem(searchCardData:any, accessOption: string) {  
    if (accessOption == "File" && searchCardData.IsFile == true) {
      var link = this.winRef.nativeWindow.document.createElement("a");
      link.setAttribute('download', 'name');
      link.href = this.bs.config.lmsBaseUrl+searchCardData.FilePath;
      link.target='_blank' ;
      link.download=searchCardData.FilePath;
      this.winRef.nativeWindow.document.body.appendChild(link);
      link.click();
      link.remove();
    }
    else{
      if (accessOption == "resume" && searchCardData.IsResume == true) {
        searchCardData.IsResumeClicked = true;
        this.bs.isResumeClicked = true;  
      }
      else {
        searchCardData.IsResumeClicked = false;
        this.bs.isResumeClicked = false;  
      } 
      this.openEvent.emit(searchCardData);
    }
  }
}
